import tw, { styled } from "twin.macro";

interface StyledSkeletonHomeCardProps {
  $isLargeCard?: boolean;
  $screenSizeQuery?: breakpointDimensions;
}
interface StyledSkeletonHomeContainerProps {
  $screenSizeQuery?: breakpointDimensions;
}

export type breakpointDimensions = "503PX" | "973PX" | "1208PX" | undefined;

const styles = {
  StyledSkeletonProductContainer: {
    base: tw`relative gap-s flex flex-col mb-6
    medium:(gap-sm)
    large:(gap-m)
  `,
    head: tw`flex items-center justify-between`,
    wrapper: tw`overflow-hidden flex gap-2`,
  },
  skeletonHomeWrapper: {
    base: tw`grid gap-2  grid-cols-[repeat(2,minmax(8.75rem,1fr))] `,
    sizeQuery: {
      "503PX": tw`grid grid-cols-[repeat(3,minmax(9.25rem,1fr))]`,
      "973PX": tw`grid-cols-[repeat(5,minmax(11.25rem,1fr))]`,
      "1208PX": tw`grid-cols-[repeat(6,minmax(11.25rem,1fr))]`,
    },
    card: {
      base: tw`h-[12.063rem] w-full `,
      sizeQuery: {
        "503PX": tw`h-[9.688rem] min-[648px]:(h-[12.313rem])`,
        "973PX": tw`h-[11.25rem]`,
        "1208PX": tw`h-[12.5rem]`,
      },
    },
    largeCard: {
      position: {
        "503PX": tw`col-span-2 col-start-1 row-span-2 row-start-2 min-[738px]:(col-start-3 col-span-2 row-start-1 row-span-2)`,
        "973PX": tw`col-start-3 col-span-2 row-start-1 row-span-2`,
        "1208PX": tw`col-start-3 col-span-2 row-start-1 row-span-2`,
      },
    },
  },
  StyledSkeletonSearchAndFilterGallery: tw`flex gap-s pb-ml px-[2.813rem]`,
};
export const StyledSkeletonProductContainer = styled.div`
  ${styles.StyledSkeletonProductContainer.base}

  .head {
    ${styles.StyledSkeletonProductContainer.head}
  }

  .wrapper {
    ${styles.StyledSkeletonProductContainer.wrapper}
  }
`;

interface StyledSkeletonHomeCardProps {
  $isLargeCard?: boolean;
}

export const StyledSkeletonHomeWrapper = styled.div<StyledSkeletonHomeContainerProps>`
  ${styles.skeletonHomeWrapper.base}

  ${({ $screenSizeQuery }) =>
    $screenSizeQuery !== undefined && styles.skeletonHomeWrapper.sizeQuery[$screenSizeQuery]}

  /* Centrar la tarjeta grande en la primera línea */
  & > div:nth-child(4) {
    ${({ $screenSizeQuery }) =>
      $screenSizeQuery !== undefined && styles.skeletonHomeWrapper.largeCard.position[$screenSizeQuery]}
  }
`;

export const StyledSkeletonHomeCard = styled.div<StyledSkeletonHomeCardProps>`
  ${styles.skeletonHomeWrapper.card.base}
  ${({ $screenSizeQuery }) =>
    $screenSizeQuery !== undefined && styles.skeletonHomeWrapper.card.sizeQuery[$screenSizeQuery]}
  ${({ $isLargeCard }) => $isLargeCard && tw`min-[503px]:(min-w-[18.75rem] h-full max-h-full large:h-full)`}
`;

export const StyledSkeletonSearchAndFilterGallery = styled.div`
  ${styles.StyledSkeletonSearchAndFilterGallery}
`;
